import {User} from "../models/user.js";
import {globals} from "./globals.js";
import {captureError} from "./helpers.js";
import {requestTimeout} from "../ui/ui-helpers.js";

function loadUser() {
	return JSON.parse(localStorage.getItem('tempUserData')) || User();
}

function saveUser(userData) {
	window.localStorage.setItem('tempUserData', JSON.stringify(userData));
}

async function syncUserData() {
	if (window.navigator.onLine) {
		let user = loadUser();
		return new Promise((resolve, reject) => {
			$.ajax({
				type: "POST",
				contentType: "application/json; charset=utf-8",
				url: globals.baseUrl + '/_sync_user_data',
				data: JSON.stringify({
					userData: user
				}),
				timeout: requestTimeout,
				success: async (data) => {
					if (data && Object.keys(data).length !== 0) {
						user.eventsPlayed = data['eventsPlayed'];
						user.unlockedSegments = data['unlockedSegments'];
						user.storiesCompleted = data['storiesCompleted'];
						user.talentRequestTypesCompleted = data['talentRequestTypesCompleted'];
						user.unlockedPowerups = data['unlockedPowerups'];
						user.unlockedCharacters = data['unlockedCharacters'];
						user.unlockedCombinations = data['unlockedCombinations'];
						saveUser(user);
					}
					resolve();
				},
		        error: function (jqXHR, status, errorThrown) {
					captureError(new Error('error for sync user data: ' + errorThrown));
					resolve();
				}
			});
		});
	}
}

export {loadUser, saveUser, syncUserData}